import { Navigate } from "react-router-dom";
import React, { useContext } from "react";
import { NawyPassportContext } from "@/modules/common/context/nawy-passport.provider";
import {
  EnvironmentVariables,
  OrganizationTierTypes,
} from "@/modules/common/types";
import { Permission } from "@/modules/common/types";
import useAuth from "../../hooks/auth.hook";

const RouteGuard: React.FC<{
  allowedPermissions?: Permission[];
  allowedTiers?: OrganizationTierTypes[];
  children: React.ReactNode;
}> = ({ allowedPermissions, allowedTiers, children }) => {
  const { permissions } = useContext(NawyPassportContext);

  const { user } = useAuth();

  const userRoles = user?.["cognito:groups"];

  if (userRoles?.includes("crm-super-admin")) {
    return <>{children}</>;
  }

  const userHasPermission = (permission: Permission) => {
    return permissions?.some((p) => p.name === permission.name) || false;
  };

  const hasRequiredPermission = allowedPermissions?.some((permission) =>
    userHasPermission(permission)
  );

  const hasRequiredTiers = allowedTiers?.some(
    (tier) => EnvironmentVariables.COMPANY_NAME.toString() === tier
  );

  if (
    (allowedPermissions && !hasRequiredPermission) ||
    (allowedTiers && !hasRequiredTiers)
  ) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default RouteGuard;
